import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../rootReducer';
import { updateUserActiveStatusBulk } from './updateUserActiveStatusBulk.thunks';

export interface FormState {
  loading: boolean;
  error: string | null;
}

export const initialState: FormState = {
  error: null,
  loading: false
};

const getForm = (state: RootState): FormState => state.users.form;

export const selectors = {
  getForm
};

const extraReducers = {
  [updateUserActiveStatusBulk.pending.type]: (state: FormState): void => {
    state.loading = true;
    state.error = null;
  },
  [updateUserActiveStatusBulk.fulfilled.type]: (state: FormState): void => {
    state.loading = false;
  },
  [updateUserActiveStatusBulk.rejected.type]: (state: FormState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
  }
};

const bulkSlice = createSlice({
  name: 'activeStatusBulk',
  initialState,
  reducers: {},
  extraReducers
});

export default bulkSlice.reducer;

export const actions = bulkSlice.actions;
export const caseReducers = bulkSlice.caseReducers;
